module.exports = __webpack_public_path__ + "img/germany.94bfe94b.svg";